'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const styleEncapsulation = require('@zapier/style-encapsulation');
const react = require('@emotion/react');
const theme_Colors = require('../../../../theme/Colors.cjs.js');
const components_marketing_CTA_CTATextContent = require('../CTATextContent.cjs.js');
const components_marketing_CTA_utils = require('../utils.cjs.js');
const theme_LegacyColorMap = require('../../../../theme/LegacyColorMap.cjs.js');
const styleMixins_reset = require('../../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("CTAStandard", {
  root: (backgroundColor) => react.css`
    ${styleMixins_reset.boxSizing};
    background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[backgroundColor]]};
    padding: 40px 20px;
    @media screen and (min-width: 768px) {
      padding: 60px 30px;
    }

    @media screen and (min-width: 1230px) {
      padding: 80px 20px;
    }
  `,
  content: (maxWidth) => react.css`
    ${styleMixins_reset.boxSizing};
    display: grid;
    align-items: center;
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
    max-width: ${maxWidth}px;
    margin: 0 auto;

    @media screen and (min-width: 768px) {
      gap: 90px;
      grid-template-columns: repeat(2, 1fr);
    }
  `,
  mediaContent: react.css`
    ${styleMixins_reset.boxSizing};
    @media screen and (min-width: 768px) {
      margin: 0 auto;
    }
  `
});
const CTAStandard = ({ backgroundColor = "white", heading, subHeading, ctaText, ctaHref, ctaBtnColor, description, onCtaClick, onCtaKeyDown, children, maxWidth = 1170, ctaTarget }) => {
  const bgColor = components_marketing_CTA_utils.getBgColor(backgroundColor);
  return react.jsx(
    "div",
    { css: Styles.root(bgColor), "data-zds": true },
    react.jsx(
      "div",
      { css: Styles.content(maxWidth), "data-zds": true },
      react.jsx(components_marketing_CTA_CTATextContent.CTATextContent, { heading, subHeading, description, ctaText, ctaHref, ctaBtnColor, onCtaClick, onCtaKeyDown, bgColor, ctaTarget }),
      react.jsx("div", { css: Styles.mediaContent, "data-testid": "media-content", "data-zds": true }, children)
    )
  );
};

exports.CTAStandard = CTAStandard;
//# sourceMappingURL=CTAStandard.cjs.js.map
